// Records who is trying the demo.
//
// artifacts/demo-analytics/…/demoUsers/{uid} is write-only from the browser
// (see firestore.rules) because it holds real email addresses. Read it with
// `node scripts/demo-users.js`.

import { doc, increment, serverTimestamp, setDoc } from "firebase/firestore";
import { DEMO_NS } from "./demoConfig";

export async function recordVisitor(db, user, isNewIdentity) {
  const email = user.email || "";
  // The caller's `isNewIdentity` cannot be trusted: signInWithPopup sets the
  // credential on the Auth instance *before* its promise resolves, so
  // DemoBoot's onAuthStateChanged listener wins the race, calls us with
  // `false`, and its `preparing` guard then swallows DemoAuthScreen's
  // `onAuthenticated(user, true)`. The result was that firstSeenAt was never
  // written for a Google signup, and the Telegram lead alert — which keys off
  // it — stayed silent. Auth's own metadata is authoritative for both paths.
  const meta = user.metadata || {};
  const isNew =
    isNewIdentity ||
    (!!meta.creationTime && meta.creationTime === meta.lastSignInTime);
  return setDoc(
    doc(db, "artifacts/demo-analytics/public/data/demoUsers", user.uid),
    {
      email,
      displayName: user.displayName || "",
      photoURL: user.photoURL || "",
      // The domain is the useful part for B2B: it usually names the hotel.
      emailDomain: email.includes("@") ? email.split("@").pop() : "",
      provider: user.providerData?.[0]?.providerId || "unknown",
      lastSeenAt: serverTimestamp(),
      lastSandboxNs: DEMO_NS,
      ...(isNew
        ? { firstSeenAt: serverTimestamp(), visits: 1 }
        : { visits: increment(1) }),
    },
    { merge: true }
  );
}
